import { useState } from "react";
import { AsyncPaginate } from "react-select-async-paginate";
import { getEnvVariables } from "../../utils/helpers/getEnvVariables";

const SelectAsyncPaginateDepartamentoBogota = (props) => {
  const [itemsDonwload, setItemsDonwload] = useState({});
  const { API_URL } = getEnvVariables();
  const IDBOGOTA = 11

  const getDefaultValue = async () => {
    if (props.id) {
      const response = await fetch(
        `${API_URL}/utils/departamentos/?page=${1}`
      );
      const responseJSON = await response.json()
      const defaultValue = responseJSON?.results.filter(item => item.id === IDBOGOTA)[0]
      props.onChange(defaultValue)
    }
  }

  const loadOptions = async (searchQuery, loadedOptions, { page }) => {
    let resp = itemsDonwload;
    let nextHas = null;
    if (searchQuery.length == 0) {
      const response = await fetch(
        `${API_URL}/utils/departamentos/?page=${page}`
      );
      resp = await response.json();
      setItemsDonwload({
        ...resp,
        results: [...resp.results, ...(itemsDonwload?.results || [])],
      });
      nextHas = resp.next;
    } else {
      resp = itemsDonwload;
    }
    const options = resp?.results.filter(item => item.id === IDBOGOTA)
    return {
      options,
      hasMore: nextHas !== null,
      additional: {
        page: searchQuery ? 2 : page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  return (
    <AsyncPaginate
      styles={props.styles}
      key={JSON.stringify()}
      value={props.value || getDefaultValue || ""}
      loadOptions={loadOptions}
      getOptionValue={(option) => option.nombre}
      getOptionLabel={(option) => option.nombre}
      onChange={onChange}
      placeholder="Seleccionar"
      additional={{
        page: 1,
      }}
      isSearchable
      filterOption={(option, inputValue) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())
      }
    />
  );
};

export default SelectAsyncPaginateDepartamentoBogota;